export const personalDataCollection = {
    title: 'Сбор личных сведений',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'Мы информируем посетителей нашего сайта, когда нам требуется получить информацию, которая позволяет установить их контактные данные. Эти данные запрашиваются при отправлении нам электронного сообщения с вопросами или предложениями по сотрудничеству.',
        },
        {
            type: 'text',
            value: 'На сайте Компании осуществляется сбор статистики посещаемости сайта. Статистическая информация может включать в себя:',
        },
        {
            type: 'list',
            items: [
                'IP-адрес пользователя;',
                'географическое местоположение;',
                'тип и версию браузера;',
                'количество предыдущих посещений;',
                'посещаемые страницы;',
                'адрес сайта, с которого пользователь осуществил переход на сайт Компании.',
            ],
        },
        {
            type: 'text',
            value: 'Данная информация используется для обработки статистических данных по использованию сайта для повышения качества предоставляемых сервисов.',
        },
    ],
};
